// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__KyRFQ","activeNavButton":"Navbar_activeNavButton__WZ3Np"};